export const PERMISSION_RESOURCE_CODES = {
  workbench: 'work-order-workbench',
  todo: 'work-order-todo',
  myWorkOrders: 'my-work-orders',
  workOrders: 'work-orders',
  templates: 'work-order-templates',
  statistics: 'work-order-statistics',
  workOrderDetail: 'work-order-detail',
  settings: 'settings',
} as const;

export const PERMISSION_ACTION_CODES = {
  myWorkOrders: { create: 'create' },
  workOrders: { create: 'create' },
  templates: {
    create: 'create',
    edit: 'edit',
    copyTemplate: 'copy-template',
    publishTemplate: 'publish-template',
  },
  workOrderDetail: {
    claimTask: 'claim-task',
    acceptTask: 'accept-task',
    submitResult: 'submit-result',
    confirmCompletion: 'confirm-completion',
    rejectCompletion: 'reject-completion',
    transferTask: 'transfer-task',
    cancelWorkOrder: 'cancel-work-order',
  },
  settings: { manageRolePermissions: 'manage-role-permissions' },
} as const;
